import React from 'react'
import Header from '../Components/Header/Header'
import Footer from '../Components/Footer/Footer'
import Wish from '../Components/Wishlist/Wish'


function WishList() {
  return (
    <div>
      <Header />
        <Wish />
      <Footer />
    </div>
  )
}

export default WishList
